<script setup lang="ts">
import { ref, watch } from 'vue'
import { type UserDetail } from '@/api/functions/users/get-user-detail.action'

const props = defineProps<{
  userData: UserDetail
}>()

const email = ref('')
const isShowEditEmail = ref(false)

watch(
  () => props.userData,
  (newVal) => {
    email.value = newVal?.email || ''
  },
  { deep: true, immediate: true }
)
</script>


<template>
  <div class=" bg-white  rounded-xl  grid lg:grid-cols-3 my-6 lg:h-28 p-8 gap-6 ">
    <div class="w-full flex items-center justify-between  text-sm ">
      <span class="text-[#2d5396]">ایمیل:</span>
      <span v-if="!isShowEditEmail" class="font-fa text-[#1b325a]">
        {{ userData?.email }}
      </span>
      <div v-else>
        <Input v-model="email" name="amount" label="ایمیل جدید را وارد کنید" type="email" class="h-11!" />
      </div>
    </div>

    <div></div>

    <div class=" flex  items-center justify-end">
      <Button @click="isShowEditEmail = !isShowEditEmail" :isAdmin="true"
        class="w-1/2 lg:w-auto  rounded-[10px] px-5 h-10! py-0 text-[13px] font-normal me-2">
        ویرایش
      </Button>
    </div>
  </div>
</template>
